import { GuestDetails, RsvpDetails, StepsTranslationsStrings } from "../../models/api/rsvpApiTypes"
import { CORE_STEP_NAMES, TranslationsStringsType } from "../../models/enum/rsvpEnum"
import useStepNavigation from "../../hook/useStepNavigation"
import BooleanSwitch from "../Inputs/BooleanSwitch"

interface StepRsvpProps {
  buttonColor?: string
  strings?: StepsTranslationsStrings[]
  rsvp: RsvpDetails
  setRsvp: (rsvp: RsvpDetails) => void
  setStep: (name: string) => void
  stepPipeline: string[]
}

export default function StepRsvp({ buttonColor, strings, rsvp, setStep, stepPipeline, setRsvp }: StepRsvpProps) {
  const { goNext, goToSummary } = useStepNavigation(stepPipeline, CORE_STEP_NAMES.RSVP, setStep)

  const setFlag = (accepted: boolean, guest: GuestDetails) => {
    const newGuests = rsvp.invitation.guests.map((g) => {
      if (g.id === guest.id) {
        g = {
          ...guest,
          rsvp: {
            accepted,
            arrivalDate: accepted ? g.rsvp.arrivalDate : null,
            email: accepted ? g.rsvp.email : null,
            intolerances: accepted ? g.rsvp.intolerances : [],
            busTransferNeeded: accepted ? g.rsvp.busTransferNeeded : false,
          },
          answers: accepted ? g.answers : [],
        }
      }
      return g
    })
    setRsvp({ ...rsvp, invitation: { ...rsvp.invitation, guests: newGuests } })
  }

  const setNextStep = () => {
    let hasOneGuestAccepted = false
    rsvp.invitation.guests.forEach(function (s) {
      if (s.rsvp.accepted === true) {
        hasOneGuestAccepted = true
      }
    })

    if (hasOneGuestAccepted) {
      goNext()
    } else {
      goToSummary()
    }
  }

  return (
    <>
      <div style={{ display: "flex", justifyContent: "right", color: "#27272E", fontWeight: "bold" }}>
        {strings?.find((x) => x.type === TranslationsStringsType.VALUETITLE)?.value}
      </div>
      {rsvp.invitation.guests.map((guest) => (
        <div key={guest.id} style={{ display: "flex", flexDirection: "row", alignItems: "center", marginTop: "5px" }}>
          <label className="box-form-label">
            {guest.name} {guest.surname}
          </label>
          <BooleanSwitch checked={guest.rsvp.accepted} onChange={(checked) => setFlag(checked, guest)} />
        </div>
      ))}

      <button
        type="button"
        className="btn btn-primary box-button-single"
        style={{ backgroundColor: buttonColor, borderColor: buttonColor }}
        onClick={setNextStep}
      >
        {strings?.find((x) => x.type === TranslationsStringsType.MAINBUTTON)?.value}
      </button>
    </>
  )
}
